import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installThemeTokens, applyTheme, readThemeFromUrl } from "@/theme/themes";

// Install tokens and theme before first paint so nothing flashes. The page title is set once the
// requested proposal has loaded (see App.js).
installThemeTokens();
applyTheme(readThemeFromUrl());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
